<div id="course-export">

    <div id="course-export-dialog" class="fw-bold" *ngIf="!exporting">
        <div id="course-export-type" class="mb-3">
            <span class="me-3" *ngIf="!previewOnly">Exportador seleccionado:</span>
            <span class="me-3" *ngIf="previewOnly">Previsualización seleccionada:</span>
            <span *ngIf="type === 'desktop'">
                <i class="fas fa-desktop"></i>
                <span>PC</span>
            </span>
            <span *ngIf="type === 'mobile'">
                <i class="fas fa-mobile"></i>
                <span>Móvil</span>
            </span>
            <span *ngIf="type === 'pdf'">
                <i class="fas fa-file-pdf"></i>
                <span>PDF</span>
            </span>
        </div>

        <div id="course-export-language" class="mb-3" *ngIf="language != 'es'">
            <span class="me-3">Idioma:</span>
            <span *ngIf="language === 'en'">
                <span class="fi fi-gb fis"></span>
                <span>Inglés</span>
            </span>
            <span *ngIf="language === 'cn'">
                <span class="fi fi-cn fis"></span>
                <span>Chino</span>
            </span>
        </div>

        <div id="course-export-name" class="mb-3">
            <div *ngIf="!previewOnly">
                <div *ngIf="!multiTransl">
                    <label>
                        <span>Nombre del curso exportado:</span>
                        <input id="course-export-name-input" type="text" class="form-control mt-3" size="200" [(ngModel)]="name">
                    </label>
                </div>
                <div *ngIf="multiTransl">
                    <div *ngIf="type != 'pdf'">
                        <div class="mb-3" *ngFor="let t of translations">
                            <label>
                                <span *ngIf="t == 'es'">Nombre del curso exportado (Español):</span>
                                <span *ngIf="t == 'ca'">Nombre del curso exportado (Catalá):</span>
                                <input type="text" class="form-control mt-3" size="200" [(ngModel)]="name[t]">
                            </label>
                        </div>
                    </div>

                    <div *ngIf="type == 'pdf'">
                        <div class="mb-3">
                            <label class="me-3">
                                <input type="radio" class="me-1" name="pdf-export-transl" [(ngModel)]="transl" value="all">
                                <span>Todas</span>
                            </label>
                            <label class="me-3" *ngFor="let t of translations">
                                <input type="radio" class="me-1" name="pdf-export-transl" [(ngModel)]="transl" [value]="t">
                                <span *ngIf="t == 'es'">Español</span>
                                <span *ngIf="t == 'ca'">Catalá</span>
                            </label>
                        </div>
                        
                        <div *ngIf="transl == 'all'">
                            <div class="mb-3" *ngFor="let t of translations">
                                <label>
                                    <span *ngIf="t == 'es'">Nombre del curso exportado (Español):</span>
                                    <span *ngIf="t == 'ca'">Nombre del curso exportado (Catalá):</span>
                                    <input type="text" class="form-control mt-3" size="200" [(ngModel)]="name[t]">
                                </label>
                            </div>
                        </div>
                        <div *ngIf="transl != 'all'">
                            <div class="mb-3">
                                <label>
                                    <span>Nombre del curso exportado:</span>
                                    <input type="text" class="form-control mt-3" size="200" [(ngModel)]="name[transl]">
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="previewOnly">
                <div *ngIf="!multiTransl">
                    <p class="fw-bold">
                        Nombre del curso: {{ name }}
                    </p>
                </div>
                <div *ngIf="multiTransl">
                    <p class="fw-bold" *ngIf="name['es'] == ''">
                        Nombre del curso (Español): {{ name['es'] }}
                    </p>
                    <p class="fw-bold" *ngIf="name['ca'] == ''">
                        Nombre del curso (Catalá): {{ name['ca'] }}
                    </p>
                </div>
            </div>
        </div>

        <div id="course-export-text">
            <p *ngIf="!previewOnly">Ahora se procederá a exportar el curso actual.</p>
            <p *ngIf="previewOnly">Ahora se procederá a generar las previsualizaciones para el curso actual.</p>
            <p>Esta operación puede tardar varios minutos dependiendo del tamaño del curso.</p>
        </div>

        <button class="btn btn-success me-3" (click)="export()">
            <i class="fas fa-check"></i>
            <span>Continuar</span>
        </button>
        <button class="btn btn-danger me-3" (click)="close()">
            <i class="fas fa-times"></i>
            <span>Cancelar</span>
        </button>
    </div>

    <div id="course-export-exporting" *ngIf="exporting || exportSuccess || exportError">
        <div class="mb-4" *ngIf="exporting && !exportSuccess && !exportError">
            <h2 *ngIf="!previewOnly">
                <i class="fas fa-spinner fa-spin me-3"></i>
                <span>Exportando el curso, espere por favor...</span>
            </h2>
            <h2 *ngIf="previewOnly">
                <i class="fas fa-spinner fa-spin me-3"></i>
                <span>Generando previsualizaciones, espere por favor...</span>
            </h2>
        </div>

        <div class="text-success mb-4" *ngIf="exportSuccess">
            <h2 *ngIf="!previewOnly">
                <i class="fas fa-check me-3"></i>
                <span>¡Curso exportado correctamente!</span>
            </h2>
            <h2 *ngIf="previewOnly">
                <i class="fas fa-check me-3"></i>
                <span>¡Previsualizaciones generadas correctamente!</span>
            </h2>
        </div>

        <div class="text-danger mb-4" *ngIf="exportError">
            <h2 class="text-danger" *ngIf="!previewOnly">
                <i class="fas fa-times me-3"></i>
                <span>Ha habido un error al exportar el curso.</span>
            </h2>
            <h2 class="text-danger" *ngIf="previewOnly">
                <i class="fas fa-times me-3"></i>
                <span>Ha habido un error al generar las previsualizaciones.</span>
            </h2>

            <div class="mt-3">
                <button class="btn btn-success me-3" (click)="export()">
                    <i class="fas fa-redo-alt"></i>
                    <span>Reintentar</span>
                </button>
                <button class="btn btn-danger me-3" (click)="close()">
                    <i class="fas fa-times"></i>
                    <span>Cancelar</span>
                </button>
            </div>
        </div>

        <div id="course-export-status" *ngIf="status != ''">
            <p><b>Estado:</b> {{ status }}</p>
            <p>{{ statusMsg }}</p>
        </div>

        <div id="course-export-file" class="mb-3" *ngIf="exportSuccess && exportedLink && !previewOnly">
            <a class="fw-bold" href="{{ exportedLink }}" target="_blank">
                <div *ngIf="type != 'pdf'">
                    <i class="fas fa-file-archive"></i>
                    <i class="fas fa-download"></i>
                    <span>Descargar ZIP</span>
                </div>
                <div *ngIf="type == 'pdf'">
                    <i class="fas fa-file-pdf"></i>
                    <i class="fas fa-download"></i>
                    <span>Descargar PDF</span>
                </div>
            </a>
        </div>

        <div id="course-export-log" class="mb-3" *ngIf="exportSuccess && logLink && !previewOnly">
            <a class="fw-bold" href="{{ logLink }}" target="_blank">
                <i class="fas fa-clipboard"></i>
                <i class="fas fa-download"></i>
                <span>Descargar logs</span>
            </a>
        </div>

        <div id="course-export-activities-tests-errors" class="alert alert-danger" *ngIf="activitiesTestsErrors.length > 0">
            <p class="fw-bold">Se ha detectado errores en las siguientes actividades / evaluaciones:</p>
            <ul>
                <li *ngFor="let error of activitiesTestsErrors;">{{ error }}</li>
            </ul>
        </div>

        <div id="course-export-multimedia-errors" class="alert alert-danger" *ngIf="multimediaErrors.length > 0">
            <p class="fw-bold">Se ha detectado errores multimedia en los siguientes enunciados:</p>
            <ul>
                <li *ngFor="let error of multimediaErrors;">{{ error }}</li>
            </ul>
        </div>
        
        <div id="course-export-html-errors" class="alert alert-danger" *ngIf="htmlErrors.length > 0">
            <p class="fw-bold">Se ha detectado HTML inválido en los siguientes enunciados:</p>
            <ul>
                <li *ngFor="let error of htmlErrors;">{{ error }}</li>
            </ul>
        </div>

        <div id="course-export-unit-previews" *ngIf="exportSuccess && unitPreviews.length > 0">
            <p class="fw-bold">Previsualización de las unidades:</p>
            <ul>
                <li *ngFor="let unit of unitPreviews; let u = index;">
                    <a href="{{ baseUrl }}/php/brainscorm/{{ unit }}" target="_blank">
                        <i class="fas fa-eye"></i>
                        <i class="fas fa-book"></i>
                        <span>Previsualizar Unidad {{ u + 1 }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <!--
        <div id="course-export-moodle" class="mt-3" *ngIf="exportSuccess && !previewOnly">
            <!-- <div id="course-export-moodle" *ngIf="exportSuccess"> ->
            <div>
                <p class="fw-bold">Ahora que el curso está exportado, puedes enviarlo directamente a la plataforma FORTEC. Esto actualizará los contenidos actualmente presentes.</p>
                <p class="fw-bold">Primero selecciona un curso de la lista, y despues pulsa en el botón.</p>
            </div>
            
            <div class="ng-autocomplete" class="mb-3">
                <ng-autocomplete 
                    [data]="moodleCourses"
                    [searchKeyword]="'name'"
                    placeholder="Seleccionar curso"
                    (selected)='courseAutocompleteOnSelect($event)'
                    (inputChanged)='courseAutocompleteOnChangeSearch($event)'
                    (inputFocused)='courseAutocompleteOnFocused($event)'
                    [itemTemplate]="itemTemplate"
                    [notFoundTemplate]="notFoundTemplate">                                 
                </ng-autocomplete>
    
                <ng-template #itemTemplate let-item>
                    <a [innerHTML]="item.name"></a>
                </ng-template>
    
                <ng-template #notFoundTemplate>
                    <div>Curso no encontrado</div>
                </ng-template>
            </div>
    
            <button class="btn btn-primary" (click)="exportMoodle()" [attr.disabled]="sendingToMoodle ? 'disabled' : null">
                <i class="fas fa-graduation-cap"></i>
                <i class="fas fa-arrow-right"></i>
                <i class="fas fa-server"></i>
                <span>Enviar a plataforma FORTEC</span>
            </button>

            <div class="my-4" *ngIf="sendingToMoodle && !sendToMoodleSuccess && !sendToMoodleError">
                <h2>
                    <i class="fas fa-spinner fa-spin me-3"></i>
                    <span>Enviando a plataforma, espere por favor...</span>
                </h2>
            </div>

            <div class="my-4" *ngIf="sendToMoodleSuccess">
                <h2 class="text-success">
                    <i class="fas fa-check me-3"></i>
                    <span>¡Curso enviado a plataforma correctamente!</span>
                </h2>
            </div>

            <div class="my-4" *ngIf="sendToMoodleError">
                <h2 class="text-danger">
                    <i class="fas fa-times me-3"></i>
                    <span>Ha habido un error al enviar el curso a plataforma.</span>
                </h2>

                <!--
                <div class="mt-3">
                    <button class="btn btn-success me-3" (click)="export()">
                        <i class="fas fa-redo-alt"></i>
                        <span>Reintentar</span>
                    </button>
                    <button class="btn btn-danger me-3" (click)="close()">
                        <i class="fas fa-times"></i>
                        <span>Cancelar</span>
                    </button>
                </div>
                ->
            </div>
        </div>
        -->

    </div>

</div>